module.exports = __webpack_public_path__ + "img/PC-WX-FEATURE2.3d034a0.png";